import { Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import Header from './components/Header'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import ProgramsPage from './pages/ProgramsPage'
import AboutPage from './pages/AboutPage'
import BlogsPage from './pages/BlogsPage'
import RoboticsBlogPage from './pages/RoboticsBlogPage'
import STEMWorkshopsBlogPage from './pages/STEMWorkshopsBlogPage'
import ContactPage from './pages/ContactPage'
import RegisterPage from './pages/RegisterPage'
import EntrepreneurshipBlog from './pages/blogs/EntrepreneurshipBlog';

//main
function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex-grow page-background"
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/robotics-guide" element={<RoboticsBlogPage />} />
          <Route path="/blogs/stem-workshops" element={<STEMWorkshopsBlogPage />} />
          <Route path="/blogs/entrepreneurship" element={<EntrepreneurshipBlog />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Routes>
      </motion.main>
      <Footer />
    </div>
  )
}

export default App
